module.exports = __webpack_public_path__ + "img/organization.9b2260b7.svg";